<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs6>
                        <v-card color="#64b5f6" dark>
                            <v-card-title>
                                <v-icon large left>mdi-account-card-details-outline</v-icon>
                                <span class="title">Account Credentials</span>
                            </v-card-title>

                            <div v-for="(c, i) in credentials" :key="c.id">
                                <v-divider color="#eee" class="mx-3 mt-2" v-if="i != 0 && c.merchantName"></v-divider>
                                <v-card-text v-if="c.entityId" class="text-xs-left">
                                    
                                    <h3 v-if="c.merchantName">{{ c.merchantName }}</h3>
                                    <br v-if="c.merchantName"><b>Channel Name:</b> {{ c.channelName }}
                                    <br><b>Entity Id:</b> {{ c.entityId }}
                                    <br><b>Access Token:</b> {{ c.accessToken }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            merchantId: localStorage.merchant_access,
            credentials: []
        }
    },
    beforeMount() {
       this.getCredentials();
    },
    methods: {
        getCredentials() {
            axios({
            method: 'post',
            url: 'https://controlapi.totalprocessing.com/api/client-get-merchant-credentials',
            data: { userId: localStorage.user_id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                const temp = response.data;

                let prev = temp[0].merchantName;
                for(let i = 0; i < temp.length; i++) {
                    if(i > 0) {
                        if(temp[i].merchantName == prev) {
                            prev = temp[i].merchantName;
                            temp[i].merchantName = null;
                        }
                        else {
                            prev = temp[i].merchantName;
                        }
                    }
                }
                this.credentials = temp;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
    }
}
</script>

<style>
 
</style>